import { Pipe, PipeTransform } from '@angular/core';
import { Coords, GeoPoint } from '@rma/generic/domain/types';
import {
  GOOGLE_MAPS_STATIC_MARKER,
  GOOGLE_MAPS_STATIC_PROPERTY_MARKER,
  GOOGLE_MAPS_STATIC_REVIEWS_MARKER,
  MapMarkerStatus,
  MapMarkerType,
  RmaMapMarker,
} from '@rma/maps/domain';
import { fromPartial } from '@total-typescript/shoehorn';

@Pipe({
  name: 'coordsToMapMarker',
  standalone: true,
})
export class CoordsToMapMarkerPipe implements PipeTransform {
  transform(coords: GeoPoint | Coords, config?: { mapType: MapMarkerType; status: MapMarkerStatus }): RmaMapMarker | null {
    let latLon: GeoPoint;

    if (this.isGeoPoint(coords)) {
      latLon = coords;
    } else {
      latLon = {
        lat: coords.latitude,
        lon: coords.longitude,
      };
    }

    if (latLon.lat === 0 && latLon.lon === 0) {
      return null;
    }

    return {
      position: { lat: latLon.lat, lng: latLon.lon },
      detail: fromPartial({
        coords: { lat: latLon.lat, lon: latLon.lon },
        icon: config ? this.getIcon(config.mapType, config.status) : GOOGLE_MAPS_STATIC_MARKER,
      }),
      options: {},
    };
  }

  private getIcon(section: MapMarkerType, status: MapMarkerStatus): string {
    if (['active', 'primary'].includes(status)) {
      return GOOGLE_MAPS_STATIC_MARKER;
    }

    return section === 'Review' ? GOOGLE_MAPS_STATIC_REVIEWS_MARKER : GOOGLE_MAPS_STATIC_PROPERTY_MARKER;
  }

  private isGeoPoint(coords: GeoPoint | Coords): coords is GeoPoint {
    return (coords as GeoPoint).lat !== undefined;
  }
}
